import React, { useState } from 'react';
import MemberNav from './MemberNav';
import CatchGallery from './CatchGallery';
import PersonalStatsView from './PersonalStatsView';

interface MyFishingPageProps {
  onNavigate: (page: 'dashboard' | 'profile' | 'competitions' | 'catches' | 'my-stats' | 'my-fishing' | 'season-championship' | 'home') => void;
  initialTab?: 'catches' | 'stats';
}

const MyFishingPage: React.FC<MyFishingPageProps> = ({ onNavigate, initialTab = 'catches' }) => {
  const [tab, setTab] = useState<'catches' | 'stats'>(initialTab);

  return (
    <div className="min-h-screen bg-gray-50">
      <MemberNav currentPage={"dashboard" as any} onNavigate={onNavigate} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex gap-2 mb-6 border-b border-gray-200">
          <button
            onClick={() => setTab('catches')}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${tab === 'catches' ? 'border-fishing-blue text-fishing-blue' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
          >
            🎣 My Catches
          </button>
          <button
            onClick={() => setTab('stats')}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${tab === 'stats' ? 'border-fishing-blue text-fishing-blue' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
          >
            📈 My Stats
          </button>
        </div>
        {tab === 'catches' ? (
          <CatchGallery onNavigate={onNavigate} embedded />
        ) : (
          <PersonalStatsView onNavigate={onNavigate} embedded />
        )}
      </div>
    </div>
  );
};

export default MyFishingPage;
